import { useLang } from "../../context/LangContext";
import { Reveal, SplitReveal, Tilt } from "./Motion";

const Portrait = ({ initials }) => (
  <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[#0a0a0b]">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(212,175,55,0.28),transparent_60%)] transition-transform [transition-duration:1500ms] group-hover:scale-125" />
    <svg viewBox="0 0 200 250" className="absolute inset-0 h-full w-full" fill="none">
      <ellipse cx="100" cy="110" rx="86" ry="26" transform="rotate(-20 100 110)" stroke="#d4af37" strokeOpacity=".35" />
      <circle cx="100" cy="110" r="58" stroke="#fff" strokeOpacity=".12" />
    </svg>
    <span className="font-serif-i gold-text absolute inset-0 flex items-center justify-center pb-10 text-[6.5rem] leading-none transition-transform duration-1000 group-hover:scale-110" style={{ transform: "translateZ(60px)" }}>
      {initials}
    </span>
  </div>
);

export const Team = () => {
  const { t } = useLang();
  const tm = t.team;
  return (
    <section id="team" data-testid="team-section" className="relative bg-[#fafaf7] py-28 text-[#0a0a0b] md:py-40">
      <div className="wrap">
        <div className="mb-16 grid gap-6 md:mb-24 md:grid-cols-12">
          <p className="eyebrow md:col-span-3" style={{ color: "#8c6b1f" }}>{tm.eyebrow}</p>
          <h2 className="font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl md:col-span-9">
            <SplitReveal key={tm.title} text={tm.title} />
          </h2>
        </div>
        <div className="grid gap-10 md:grid-cols-3 md:gap-8">
          {tm.members.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.12}>
              <Tilt max={6} className="group" data-testid={`team-member-${i}`} data-cursor={t.cursor.team}>
                <Portrait initials={m.initials} />
                <div className="mt-7">
                  <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#8c6b1f]">{m.role}</p>
                  <h3 className="mt-3 font-display text-3xl font-bold tracking-tight">{m.name}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-black/60 md:text-base">{m.bio}</p>
                </div>
              </Tilt>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
